import { DateTime } from 'luxon';
import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const DATE_FORMAT = 'yyyy-MM-dd';

export const useDocketDateRange = () => {
  const [searchPrams, setSearchParams] = useSearchParams();

  const dayString = searchPrams.get('day') || '';

  const { date, dateIsInvalid, goForward, goBack, goToToday } = useMemo(() => {
    let date: DateTime;
    date = DateTime.fromFormat(dayString, DATE_FORMAT);

    const dateIsInvalid = !!date?.invalidReason;

    if (dateIsInvalid) {
      date = DateTime.now().startOf('day');
    }

    const goForward = () => {
      const nextDay = date.plus({ day: 1 });
      setSearchParams(params => {
        params.set('day', nextDay.toFormat(DATE_FORMAT));
        return params;
      });
    };

    const goBack = () => {
      const previousDay = date.minus({ day: 1 });
      setSearchParams(params => {
        params.set('day', previousDay.toFormat(DATE_FORMAT));
        return params;
      });
    };

    const goToToday = () => {
      const today = DateTime.now();
      setSearchParams(params => {
        params.set('day', today.toFormat(DATE_FORMAT));
        return params;
      });
    };

    return { dateIsInvalid, date, goForward, goBack, goToToday };
  }, [dayString]);

  useEffect(() => {
    if (dateIsInvalid && dayString) {
      setSearchParams(params => {
        params.delete('day');
        return params;
      });
    }
  }, [dateIsInvalid, dayString]);

  const startEpochTime = date.startOf('day').toMillis();
  const endEpochTime = date.endOf('day').toMillis();
  const now = DateTime.now().toMillis();

  return {
    date,
    startEpochTime,
    endEpochTime,
    isToday: now >= startEpochTime && now < endEpochTime,
    isPast: now >= endEpochTime,
    isFuture: now < startEpochTime,
    goForward,
    goBack,
    goToToday,
  };
};
